// @flow
import React from 'react';
import { connect } from 'react-redux';
import NotificationSettingsCheckbox from './NotificationSettingsCheckbox';
import NotificationSettingsRowTemplate from './NotificationSettingsRowTemplate';
import setNotificationSettingsAllEmail from '../state/setNotificationSettingsAllEmail';
import setNotificationSettingsAllPush from '../state/setNotificationSettingsAllPush';

type Props = {
    settingsEmailLookup: {},
    settingsPushLookup: {},
    includeEmail: boolean,
    includePush: boolean,
    dispatch: () => any,
    token: string
};

const NotificationSettingsAllRow = ({
    settingsEmailLookup,
    settingsPushLookup,
    includeEmail,
    includePush,
    token,
    dispatch
}: Props) => {
    const titleColumn = <div>All notifications</div>;

    let pushColumn = null;
    let pushState = false;
    if (includePush) {
        pushState = Object.keys(settingsPushLookup).every(
            (key: string) => settingsPushLookup[key]
        );
        pushColumn = (
            <NotificationSettingsCheckbox
                checked={pushState}
                onChange={(enabled: boolean) => {
                    dispatch(setNotificationSettingsAllPush(enabled, token));
                }}
            />
        );
    }

    let emailColumn = null;
    let emailState = null;
    if (includeEmail) {
        emailState = Object.keys(settingsEmailLookup).every(
            (key: string) => settingsEmailLookup[key]
        );
        emailColumn = (
            <NotificationSettingsCheckbox
                checked={emailState}
                onChange={(enabled: boolean) => {
                    dispatch(setNotificationSettingsAllEmail(enabled, token));
                }}
            />
        );
    }

    return (
        <NotificationSettingsRowTemplate
            firstColumn={titleColumn}
            secondColumn={pushColumn}
            thirdColumn={emailColumn}
        />
    );
};

const mapStateToProps = (state: {}, ownProps: any) => {
    return {
        ...ownProps,
        settingsEmailLookup:
            state.notificationSettings.notificationSettingsEmailLookup,
        settingsPushLookup:
            state.notificationSettings.notificationSettingsPushLookup
    };
};

export default connect(mapStateToProps)(NotificationSettingsAllRow);



// WEBPACK FOOTER //
// ./src/v5/notificationSettings/components/NotificationSettingsAllRow.jsx